const NotesColors = [
  '#FFB507',
  '#1FD0BF',
  '#EB648B'
]

export default NotesColors
